exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#end-title[data-v-5f2bf52e] {\n  margin-top: 0;\n  font-weight: 400;\n  text-align: center;\n  color: #88ad3f;\n  margin-bottom: 20px;\n  font-size: 1.5rem;\n  line-height: 2rem;\n}\n@media screen and (max-width: 767px) {\n.w-1\\/2[data-v-5f2bf52e] {\n    width: 100%;\n}\n}", ""]);

// exports
